import App from 'pages/App/container';

export default App;
